/*eslint-disable*/
import React from 'react'
import { withFormik, Field as Fieldmik } from 'formik';
import * as yup from 'yup';
import { Form as FormUi, Container, Button, Label, Modal, } from 'semantic-ui-react';
import { MyInput } from '../../apiInputComponent/myInput';
import putAxios from '../../axiosComponent/put';
const AddVendorType = ({ values, errors, touched, isSubmitting, handleSubmit, handleClose }) => {
    return (
        <>  <Modal.Header>Add Vendor Type</Modal.Header>
            <Modal.Content>
                <Container>
                    <div className="ui form">
                        <FormUi.Field>
                            <label className="labelName p-bold-600">Vendor Type Code *</label>
                            <Fieldmik name="VendorTypeCode" component={MyInput} error={values.vendorTypeCode ? false : true} placeholder="Code" />
                            {touched.VendorTypeCode && errors.VendorTypeCode ? <Label size="mini" prompt pointing>{errors.VendorTypeCode}</Label> : ''}
                        </FormUi.Field>
                        <FormUi.Field>
                            <label className="labelName p-bold-600">Vendor Type Name *</label>
                            <Fieldmik component={MyInput} error={values.VendorTypeName ? false : true} name="VendorTypeName" placeholder="Name" />
                            {touched.VendorTypeName && errors.VendorTypeName ? <Label size="mini" prompt pointing>{errors.VendorTypeName}</Label> : ''}
                        </FormUi.Field>
                    </div>
                </Container>
            </Modal.Content>
            <Modal.Actions>
                {isSubmitting ? 'Loading...' : ''}
                <Button onClick={handleClose} type="submit" size="tiny">Cancel</Button>
                <Button disabled={isSubmitting} type="submit" onClick={handleSubmit} size="tiny" primary>Submit</Button>
            </Modal.Actions>
        </>
    )
}

const FormikAddVendorType = withFormik({
    mapPropsToValues({ VendorTypeCode, VendorTypeName }) {
        return {
            VendorTypeCode: VendorTypeCode || '',
            VendorTypeName: VendorTypeName || '',
        }
    },
    validationSchema: yup.object().shape({
        // VendorTypeCode: yup.string().matches(/^[a-z\d\-_\s]+$/i, 'Invalid Characters').min(3, 'Must be more than 3 Letters').required('Vendor Type Code Required'),
        VendorTypeName: yup.string().matches(/^[a-z\d\-_\s]+$/i, 'Invalid Characters').min(3, 'Must be more than 3 Letters').required('Vendor Type Name Required')
    }),
    handleSubmit(values, { setErrors, setSubmitting }) {
        setSubmitting(true)
        let VendorTypeCode = values.VendorTypeCode.toUpperCase()
        let VendorTypeName = values.VendorTypeName.toUpperCase()

        putAxios({
            url: 'masters/vendorType',
            createItems: {
                vendorType: VendorTypeName,
                // vendorTypeCode: VendorTypeCode
            },
            created: (data) => {
                if (data.status === 1) {
                    alert("Vendor Type Added Successfully")
                    window.location.reload()
                } else {
                    setSubmitting(false)
                    alert(data.message)
                }
            }
        })

    }
})(AddVendorType)

export default FormikAddVendorType
